import { Component, OnInit } from '@angular/core';
import { NavController, Platform, ToastController } from '@ionic/angular';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { GetUserDevicesRequestAction } from '../../../angular-wallet-base/actions/devicesList.actions';
import { PreventAuthOnResumeAction } from '../../../angular-wallet-base/actions/wallet.actions';
import { getToastPosition } from '../../../angular-wallet-base/utils';
import { TranslateService } from '@ngx-translate/core';
import { PREVENT_2FA_REAUTH_TIMEOUT } from '../../../angular-wallet-base/constants';

@Component({
  selector: 'app-delete-device',
  templateUrl: './delete-device.page.html',
  styleUrls: ['./delete-device.page.scss'],
})
export class DeleteDevicePage implements OnInit {

  public device: any = {};
  public password;
  public twofacode;
  public showPwd: boolean = false;


  constructor(protected store: Store<AppState>,
              private nav: NavController,
              private toast: ToastController,
              private platform: Platform,
              private translate: TranslateService,
              private membersPortal: MembersPortalService,
              private activatedRoute: ActivatedRoute) { 

  }

  async ngOnInit() {
    this.store.dispatch(new PreventAuthOnResumeAction({preventLogout: true, preventAuthDuration: PREVENT_2FA_REAUTH_TIMEOUT}));
    let deviceObj = this.activatedRoute.snapshot.queryParams.device;
    this.device = JSON.parse(deviceObj);
  }

  ngOnDestroy() {
    this.store.dispatch(new PreventAuthOnResumeAction({ preventLogout: false }));
  }

  backToDevicesList() {
    this.nav.pop();
  }

  async confirmRemoveDevice() {
    try {
      await this.membersPortal.deleteUserDevice(this.password, this.twofacode.toString(), this.device);
      this.store.dispatch(new GetUserDevicesRequestAction());
      this.presentToast('settings.toast_msgs.ok_hdr','settings.toast_msgs.remove_device_success_msg');
      this.backToDevicesList()
    } catch(err) {
      this.presentToast('settings.toast_msgs.err_hdr','settings.toast_msgs.remove_device_err_msg');
    }

  }

  toggleShowPwd() {
    this.showPwd = !this.showPwd;
  }

  async presentToast(hdr,msg) {
    const toast = await this.toast.create({
      header: await this.translate.get(hdr).toPromise(),
      message: await this.translate.get(msg).toPromise(),
      position: getToastPosition(this.platform),
      duration: 4000
    });
    await toast.present();
  }

}
